(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('[data-ras-player]');
    const video = dialog.querySelector('video');
    for (const button of root.querySelectorAll('[data-ras-clip]')) {
      button.addEventListener('click', () => {
        dialog.setAttribute('aria-label', button.dataset.rasCaption);
        video.src = button.dataset.rasClip;
        dialog.showModal();
        video.play().catch(() => {});
      });
    }
    dialog.addEventListener('close', () => {
      video.pause();
      video.removeAttribute('src');
      video.load();
    });
  }
  document.querySelectorAll('[data-ras-proof]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ras-proof]').forEach(init));
})();
